import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { formatCOP } from "@/lib/site";

const STATUS = { APPROVED: "Aprobado", DECLINED: "Rechazado", VOIDED: "Anulado", ERROR: "Error", PENDING: "Sigue pendiente en Wompi" };

export const PendingPayments = () => {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["admin-pending"], queryFn: () => api.get("/admin/payments/pending").then((r) => r.data), refetchInterval: 30000 });
  const [busy, setBusy] = useState(null);
  const verify = async (ref) => {
    setBusy(ref);
    try {
      const { data: r } = await api.post(`/admin/payments/${ref}/verify`);
      (r.status === "APPROVED" ? toast.success : toast.info)(`${ref}: ${STATUS[r.status] || r.status}${r.order_number ? ` · pedido ${r.order_number}` : ""}`);
      qc.invalidateQueries({ queryKey: ["admin-pending"] }); qc.invalidateQueries({ queryKey: ["admin-orders"] });
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(null);
  };
  if (!data.length) return null;
  return (
    <section data-testid="pending-payments" className="mt-8 border border-[#B18A4B]/40 bg-[#FBF6EC] p-5 text-sm">
      <h2 className="font-serif-display text-xl">Pagos pendientes de confirmar</h2>
      <p className="mt-1 text-xs text-[#5C534C]">La web los consulta con Wompi automáticamente cada 3 minutos. También puedes verificarlos ahora.</p>
      <ul className="mt-4 divide-y divide-[#1C1715]/10">
        {data.map((p) => (
          <li key={p.reference} data-testid={`pending-${p.reference}`} className="flex flex-wrap items-center justify-between gap-3 py-3">
            <span>{p.reference} · {p.customer?.name} · {formatCOP(p.total_cop)} · {new Date(p.created_at).toLocaleString("es-CO")}</span>
            <button type="button" data-testid={`pending-verify-${p.reference}`} disabled={busy === p.reference} onClick={() => verify(p.reference)}
              className="rounded-full bg-[#1C1715] px-4 py-1.5 text-xs text-white transition-colors hover:bg-[#B18A4B] disabled:opacity-50">{busy === p.reference ? "Verificando…" : "Verificar con Wompi"}</button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export const TestEmailButton = () => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/test-email"); toast.success(`Correo de prueba enviado. Responder irá a ${data.reply_to}`); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <button type="button" data-testid="test-email-button" disabled={busy} onClick={send}
      className="rounded-full border border-[#1C1715]/20 px-4 py-1.5 text-xs hover:border-[#1C1715] disabled:opacity-50">{busy ? "Enviando…" : "Enviar correo de prueba"}</button>
  );
};
